import { defineComponent as _defineComponent } from 'vue'
import CountrySwitcherModal from '@/components/buybox/country-switcher/CountrySwitcherModal.vue';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { ModalHelper } from '@/helpers/modal-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { useBuyboxLoggedInExp } from '@/components/experiments/BuyboxLoggedInExp/composables/useBuyboxLoggedInExp';
import { useFauxSwiperExp } from '@/components/experiments/FauxSwiperExp';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxCountrySwitcher',
  props: {
    hideText: { type: Boolean },
    additionalContexts: null
  },
  setup(__props: any) {

const props = __props as { hideText?: boolean; additionalContexts: SnowplowContext[] };

const { webLocale, countryEmoji } = useLanguageStore();

// BUYBOX_LOGGED_IN_EXP
const { trackBuyboxLoggedInExp } = useBuyboxLoggedInExp();
//BUYBOX_LOGGED_IN_EXP

// FAUX_SWIPER_EXP
const { trackFauxSwiperExp } = useFauxSwiperExp();
// FAUX_SWIPER_EXP


const openCountrySwitcherModal = () => {
	ModalHelper.openModal(CountrySwitcherModal, { closable: true });
	TrackingHelper.trackEvent('userinteraction', { action: 'country_selector_clicked' }, props.additionalContexts);

	trackBuyboxLoggedInExp({
		action: 'click',
		label: 'country_selector_clicked',
	});

	trackFauxSwiperExp({
		action: 'click',
		label: 'country_selector_clicked',
	});
};

return { __sfc: true,webLocale, countryEmoji, trackBuyboxLoggedInExp, trackFauxSwiperExp, props, openCountrySwitcherModal }
}

})